import { Model } from '@vuex-orm/core';

export interface TechAppUserInterface {
  emp_id: number;
  cognito_email: string;
  firstname: string;
  lastname: string;
  enabled: boolean | null;
  status: string | null;
}

export class TechAppUser extends Model implements TechAppUserInterface {
  emp_id!: number;
  cognito_email!: string;
  firstname!: string;
  lastname!: string;
  enabled!: boolean | null;
  status!: string | null;

  static entity = 'techAppUser';
  static primaryKey = 'emp_id';

  static state() {
    return {
      total: 0,
      fetching: false,
      error: [],
      orderedItems: []
    };
  }

  static fields() {
    return {
      emp_id: this.attr(null),
      cognito_email: this.attr(''),
      firstname: this.attr(''),
      lastname: this.attr(''),
      enabled: this.attr(null),
      status: this.attr(null)
    };
  }

  get fullName(): string {
    return `${this.firstname} ${this.lastname}`.trim();
  }

  get displayName(): string {
    return this.fullName || this.cognito_email;
  }
}
